import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Project } from "@/v2/types";

export default async function FindOneProject(id: string): Promise<Project> {
    const res = await apiClientWithRefreshToken({
        url: `/projects/${id}`,
        method: "GET",
    });

    return res.data;
}
